import type { Team } from '../types.js';

/** Mannschaft/Verein vergleichbar machen: „Ceva", „ceva " und „CEVA" sind dieselbe Mannschaft */
export function clubKey(club: string | undefined): string | undefined {
  const k = club?.trim().toLowerCase().replace(/\s+/g, ' ');
  return k || undefined;
}

/**
 * Ein Team über Spieltage hinweg wiedererkennen (docs/13 §4): Name plus
 * Mannschaft, ohne Groß/Klein und doppelte Leerzeichen. „Ceva 1 (ceva)" ist am
 * nächsten Spieltag dasselbe Paar — solange die Leitung den Namen behält;
 * der Kader aus der Saison sorgt dafür.
 */
export function teamKey(team: Pick<Team, 'name' | 'club'>): string {
  const name = team.name.trim().toLowerCase().replace(/\s+/g, ' ');
  const club = clubKey(team.club);
  return club ? `${name} (${club})` : name;
}

/**
 * Nummer am Ende des Teamnamens: „Ceva 1" → 1, „Mombarcaro3" → 3. Im
 * Liga-Modus ist das der Platz in der Aufstellung, den der Teamleiter
 * meldet — und mit Leistungsgruppen (docs/13 §7) die Gruppe. Ohne Nummer
 * `undefined`.
 */
export function teamNumber(name: string): number | undefined {
  const m = /(\d+)\s*$/.exec(name);
  return m ? Number(m[1]) : undefined;
}

/** Ungeordnete Begegnung zweier Teams — für „schon gespielt" über die Saison */
export function pairingKey(a: string, b: string): string {
  return a < b ? `${a}|${b}` : `${b}|${a}`;
}
